<template>
	<div class="publish-container">
		<div class="publish-label publish-top">置顶通知 <a-switch class="m-left-20" v-model="isNotice" /></div>
		<div>
			<span class="publish-label required-field">添加内容</span>
			<a-textarea class="width-700" v-model="content" placeholder="请输入班级圈内容，最多5000字" :auto-size="{ minRows: 5 }"
				:maxLength="2000" style="resize: none" />
		</div>
		<div class="width-700 clearfix">
			<span class="publish-label">添加照片/视频</span>
			<span class="publish-photo" :style="getBgStyle(item.url)" v-for="(item, index) in photoList"
				:key="item.id">
				<span class="publish-photo_mask">
					<svg-icon v-if="item.content_type.startsWith('video')" iconClass="videoIcon" class="m-right-10" @click="viewPreviewPhoto(index)"></svg-icon>
					<svg-icon v-else iconClass="eye" class="m-right-10" @click="viewPhoto(photoList, index)"></svg-icon>
					<svg-icon iconClass="delete" @click="delPhoto(index)"></svg-icon>
				</span>
			</span>
			<a-upload v-if="photoList.length < limitSize" :multiple="true" :accept="acceptStr" list-type="picture-card"
				:show-upload-list="false" :beforeUpload="onBeforeUpload" :customRequest="customRequest">
				<div class="publish-photo">
					<svg-icon iconClass="plus"></svg-icon>
				</div>
			</a-upload>
		</div>

		<div class="width-700" v-if="!isManager">
			<span class="publish-label">选择主题</span>
			<span :class="['publish-item', { 'publish-selected': selectedTheme.includes(theme.id) }]"
				v-for="theme in themeList" :key="theme.id" @click="selectedThemeHandle(theme.id)">
				#{{ theme.name }}
			</span>`
		</div>

		<div class="width-700" v-if="isManager">
			<span class="publish-label m-top-5">可见范围</span>
			<span :class="['publish-item', { 'publish-selected': !selectedStudent.length }]"
				@click="selectedHandle('all')">全校</span>
			<span :class="['publish-item', { 'publish-selected': selectedStudent.includes(klass.id) }]"
				v-for="klass in klassList" :key="klass.id" @click="selectedHandle(klass.id)">
				{{ klass.name }}
			</span>
		</div>

		<div class="width-700" v-else>
			<span class="publish-label m-top-5">可见范围</span>
			<span :class="['publish-item', { 'publish-selected': !selectedStudent.length }]"
				@click="selectedHandle('all')">全班</span>
			<span :class="['publish-item', { 'publish-selected': selectedStudent.includes(student.id) }]"
				v-for="student in studentList" :key="student.id" @click="selectedHandle(student.id)">
				{{ student.kid_name }}
			</span>
		</div>
		<a-button class="submit-btn" @click="submitHandle">提交</a-button>
		<app-view-img :imageList.sync="imageList" :imageIndex.sync="imageIndex" />

		<a-modal width="1000px" title="图片预览" :visible="modalInfo.visible" @cancel="cancelHandle">
			<p class="error-color" v-if="hasOverflow">当前最多只能上传 {{ limitSize - this.photoList.length }} 张图片，请移除部分图片</p>
			<div class="clearfix">
				<span class="publish-photo publish-photo_img" :style="getBgStyle(item.url)" v-for="(item, index) in fileUrlList"
					:key="item.id">
					<span class="publish-photo_mask">
						<svg-icon v-if="item.type.startsWith('video')" iconClass="videoIcon" class="m-right-10" @click="viewPreviewPhoto(index)"></svg-icon>
						<svg-icon v-else iconClass="eye" class="m-right-10" @click="viewPreviewPhoto(index)"></svg-icon>
						<svg-icon iconClass="delete" @click="delPreviewPhoto(index)"></svg-icon>
					</span>
				</span>
			</div>

			<template slot="footer">
				<div>
					<a-button class="m-right-20" @click="cancelHandle">取消</a-button>
					<a-button v-if="hasOverflow" disabled>确定</a-button>
					<a-button v-else type="primary" @click.stop="okHandle" :loading="modalInfo.loading">确定</a-button>
				</div>
			</template>
		</a-modal>

		<a-modal width="700px" title="视频预览" v-model="videoModal.visible" @cancel="videoModalCancel" @ok="videoModalCancel" destroyed>
			<video ref="video" class="modal-video" :src="videoModal.url" controls="controls" autoplay></video>
		</a-modal>
	</div>
</template>
  
<script>
import AppViewImg from "@/components/AppViewImg";
import { uploadHandle, captureFrame } from "@/utils";
import StudentService from "@/api/studentService";
import ThemeService from "@/api/themeService";
import PostService from "@/api/postService";
import { mapGetters } from "vuex";
const imageType = [
	"image/apng",
	"image/bmp",
	"image/gif",
	"image/jpeg",
	"image/pjpeg",
	"image/png",
	"image/svg+xml",
	"image/tiff",
	"image/webp",
	"image/x-icon",
	"video/mp4",
	"video/quicktime"
]
export default {
	name: "klassDetail",
	components: { AppViewImg },
	data() {
		return {
			limitSize: 30,
			imageList: [],
			imageIndex: 0,
			isNotice: false,
			klassId: undefined,
			studentList: [],
			themeList: [],
			photoList: [],
			content: undefined,
			selectedStudent: [],
			selectedTheme: [],
			acceptStr: imageType.join(","),
			fileList: [],
			fileUrlList: [],
			modalInfo: {
				visible: false,
				loading: false
			},
			videoModal: {
				visible: false,
				url: undefined
			}
		};
	},

	computed: {
		...mapGetters(["isManager", "klassList"]),
		getBgStyle() {
			return function (thumbnail_url) {
				return {
					background: `url(${thumbnail_url}) no-repeat center center`,
					backgroundSize: "cover",
				};
			};
		},

		hasOverflow() {
			return this.fileList.length + this.photoList.length - this.limitSize > 0;
		}
	},

	created() {
		this.initHandle();
	},

	methods: {
		initHandle() {
			this.klassId = this.$route.query.id;
			this.getThemeList();
			this.getStudentList();
			this.$store.dispatch("getKlassListService");

			if (this.isManager) {
				this.selectedStudent = [this.klassId];
			}
		},

		getThemeList() {
			ThemeService.getThemeListService({ klass_id: this.klassId }).then(
				(res) => {
					this.themeList = res || [];
				}
			);
		},

		getStudentList() {
			StudentService.getStudentListService({
				klass_id: this.klassId,
			}).then((res) => {
				this.studentList = res || [];
			});
		},

		delPhoto(index) {
			this.photoList.splice(index, 1);
		},

		viewPhoto(source, index, type = "thumbnail_url") {
			if (!source[index][type] || !source[index][type].startsWith("http")) return;
			// this.imageList = source.filter(item => item[type] && item[type].startsWith("http")).map(item => item[type]);
			// this.imageIndex = this.imageList.findIndex((item) => item === source[index][type]);

			let _source = source.filter(item => item[type] && item[type].startsWith("http"))
			let curIndex = index;
			const imageList = [];
			console.log("_source", _source)
			for (let i = 0; i < _source.length; i++) {
				const item = _source[i]
				if (!item.content_type.startsWith("video")) {
					imageList.push(item[type])
					continue
				}

				if (index > i) {
					curIndex = curIndex -1
				}
			}

			this.imageList = imageList
			this.imageIndex = curIndex
		},

		delPreviewPhoto(index) {
			if (this.modalInfo.loading) return;
			this.fileList.splice(index, 1);
			this.fileUrlList.splice(index, 1);
			if (!this.fileList.length) {
				this.modalInfo.visible = false;
			}
		},

		async viewPreviewPhoto(index) {
			if (this.fileList[index].type.startsWith("video")) {
				this.videoModal = {
					visible: true,
					url: URL.createObjectURL(this.fileList[index])
				}
				return
			}
			const imageList = []
			let curIndex = index;
			for (let i = 0; i < this.fileList.length; i++) {
				const item = this.fileList[i]
				if (!item.type.startsWith("video")) {
					imageList.push(URL.createObjectURL(item))
					continue
				}

				if (index > i) {
					curIndex = curIndex -1
				}
			}

			this.imageList = imageList
			this.imageIndex = curIndex
		},

		async onBeforeUpload(file, fileList) {
			this.fileList = fileList.filter(item => imageType.includes(item.type));
			const fileUrlList = []
			for (let i = 0; i < this.fileList.length; i++) {
				const item = this.fileList[i]
				if (!item.type.startsWith("video")) {
					fileUrlList.push({
						type: "image",
						url: URL.createObjectURL(item),
					})
					continue
				}

				const base64 = await captureFrame(item)
				fileUrlList.push({
					type: "video",
					url: base64
				})
			}

			this.fileUrlList = fileUrlList
			if (this.fileList.length) {
				this.modalInfo.visible = true
			}

			return false
		},

		customRequest() {
			// uploadHandle({ file: event.file, klassId: this.klassId }).then(
			// 	(imageObj) => {
			// 		this.photoList.push(imageObj);
			// 	}
			// );
		},

		selectedHandle(id) {
			if (id === "all") {
				this.selectedStudent = [];
				return;
			}

			if (this.selectedStudent.includes(id)) {
				this.selectedStudent = this.selectedStudent.filter((item) => item !== id)
			} else {
				this.selectedStudent.push(id);
			}
		},

		selectedThemeHandle(id) {
			if (this.selectedTheme.includes(id)) {
				this.selectedTheme = this.selectedTheme.filter((item) => item !== id)
			} else {
				this.selectedTheme.push(id);
			}
		},

		async submitHandle() {
			if (
				(!this.content || !this.content.trim().length) &&
				!this.photoList.length
			) {
				this.$message.warning("请输入内容/选择图片");
				return;
			}

			if (this.isManager) {
				this.managerSubmitHandle();
				return;
			}

			const params = {
				klass_id: this.klassId,
				content: this.content ? this.content.trim() : "",
				media_ids: this.photoList.map((item) => item.id),
				student_ids: this.selectedStudent,
				tag_ids: this.selectedTheme,
			};

			try {
				let result = null;
				if (this.isNotice) {
					result = await PostService.createAnnounceService(params);
				} else {
					result = await PostService.createPostService(params);
				}
				if (!result || !result.id) {
					this.$message.error("创建失败，请检查后重试");
				} else {
					this.$message.success("创建成功");
					this.$router.back();
				}
			} catch (err) {
				this.$message.error("创建失败，请检查后重试");
			}
		},

		async managerSubmitHandle() {
			const request = [];
			let klassIdList = this.selectedStudent;
			if (!this.selectedStudent.length) {
				klassIdList = this.klassList.map((item) => item.id);
			}
			const params = {
				content: this.content ? this.content.trim() : "",
				media_ids: this.photoList.map((item) => item.id),
				tag_ids: this.selectedTheme,
			};
			klassIdList.forEach((klassId) => {
				params.klass_id = klassId;
				if (this.isNotice) {
					request.push(PostService.createAnnounceService({ ...params, klass_id: klassId }));
				} else {
					request.push(PostService.createPostService({ ...params, klass_id: klassId }));
				}
			});

			Promise.all(request)
				.then(() => {
					this.$message.success("创建成功");
					this.$router.back();
				})
				.catch(() => {
					this.$message.error("创建失败，请检查后重试");
				});
		},

		cancelHandle() {
			this.modalInfo.visible = false;
		},

		okHandle() {
			const extraImage = this.fileList.length + this.photoList.length - this.limitSize
			if (extraImage > 0) {
				this.$message.warning(`当前最多只能上传 ${this.limitSize - this.photoList.length} 张图片，请移除部分图片`)
				return
			}

			const requestServer = [];
			this.fileList.forEach(file => {
				requestServer.push(uploadHandle({ file, klassId: this.klassId, showMessage: false }))
			})

			this.modalInfo.loading = true;

			Promise.all(requestServer).then(res => {
				this.photoList = [...this.photoList, ...res];
				this.$message.success("上传成功");
				this.modalInfo.loading = false;
				this.modalInfo.visible = false;
			}).catch(() => {
				this.modalInfo.loading = false;
				this.$message.error("上传异常，请重新操作");
			})
		},

		videoModalCancel () {
			this.$refs.video.pause()
			this.videoModal = {
				visible: false,
				url: undefined
			}
		}
	},
};
</script>
  
<style lang="less" scoped>
.publish {
	&-container {
		margin-top: 15px;
		margin-right: 100px;
		padding: 20px 64px 45px 45px;
		background-color: #ffffff;

		/deep/.ant-upload-picture-card-wrapper {
			display: inline-block;
			width: auto;
		}

		/deep/.ant-upload-select-picture-card {
			background-color: #ffffff;
			border: none;
		}

		/deep/.ant-upload {
			margin: 0 !important;
			padding: 0 !important;
		}

		/deep/.ant-switch-checked {
			background: #1ab752;
		}
	}

	&-label {
		display: block;
		height: 20px;
		margin: 22px 0 14px;
		font-size: 14px;
		color: #343c6a;
	}

	&-top {
		display: flex;
		flex-flow: nowrap row;
		align-items: center;
		margin: 0;
		height: 22px;
		line-height: 22px;
	}

	&-item {
		display: inline-block;
		min-width: 128px;
		height: 35px;
		padding: 0 15px;
		margin: 0 20px 20px 0;
		line-height: 33px;
		text-align: center;
		border-radius: 20px;
		background: #ffffff;
		border: 1px solid #409eff;
		font-size: 14px;
		color: #409eff;
		cursor: pointer;
	}

	&-selected {
		background: #409eff;
		color: #ffffff;
	}

	&-photo {
		position: relative;
		float: left;
		width: 134px;
		height: 120px;
		border-radius: 4px;
		font-size: 28px;
		line-height: 120px;
		background: #ececee;
		margin: 0 25px 25px 0;
		overflow: hidden;

		&_img {
			// position: absolute;
			// top: 50%;
			// left: 50%;
			// transform: translate(-50%, -50%);
			// max-width: 100%;
			// max-height: 100%;
			background-size: cover !important;
			;
		}

		&_mask {
			display: none;
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.6);
			color: #ffffff;
			text-align: center;
			cursor: pointer;
		}

		&:hover {
			.publish-photo_mask {
				display: block;
			}
		}
	}
}

.modal-video {
	width: 640px;
	height: 360px;
}
</style>
